import uPlot from 'uplot';

// Tints the part of the x range after "now" and draws a dashed now line with
// a small mono label. x values are unix seconds (ForecastComparisonChartUplot).
export const futureSpan = (u, nowSec) => {
  const { min, max } = u.scales.x;
  if (min == null || max == null || nowSec >= max) return null;
  const from = Math.max(nowSec, min);
  const left = u.valToPos(from, 'x', true);
  const right = u.valToPos(max, 'x', true);
  return { left, width: right - left, showLine: nowSec > min };
};

// Both hooks read the clock, so a redraw moves the tint, line and label
// together without rebuilding the plot.
export default function nowMarkerPlugin({ dark, clock = () => Date.now() }) {
  const tint = dark ? 'rgba(243,244,246,0.03)' : 'rgba(15,23,42,0.025)';
  const ink = dark ? 'rgba(243,244,246,0.45)' : 'rgba(17,24,39,0.4)';
  const nowSec = () => Math.floor(clock() / 1000);
  return {
    hooks: {
      drawClear: [(u) => {
        const span = futureSpan(u, nowSec());
        if (!span) return;
        const { top, height } = u.bbox;
        u.ctx.save();
        u.ctx.fillStyle = tint;
        u.ctx.fillRect(span.left, top, span.width, height);
        u.ctx.restore();
      }],
      draw: [(u) => {
        const now = nowSec();
        const span = futureSpan(u, now);
        if (!span || !span.showLine) return;
        const px = uPlot.pxRatio || 1;
        const { left, top, width, height } = u.bbox;
        const x = Math.round(span.left) + 0.5;
        const label = `NOW ${new Date(now * 1000).toISOString().slice(11, 16)} UTC`;
        const { ctx } = u;
        ctx.save();
        ctx.strokeStyle = ink;
        ctx.lineWidth = px;
        ctx.setLineDash([3 * px, 3 * px]);
        ctx.beginPath();
        ctx.moveTo(x, top);
        ctx.lineTo(x, top + height);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = ink;
        ctx.font = `${10 * px}px 'JetBrains Mono Variable', ui-monospace, monospace`;
        // uPlot leaves its last axis alignment ('right') on the context.
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        // Right of the line, or left of it when it would pass the plot edge.
        const gap = 6 * px;
        const textWidth = ctx.measureText(label).width;
        const textX = x + gap + textWidth > left + width ? x - gap - textWidth : x + gap;
        ctx.fillText(label, textX, top + 12 * px);
        ctx.restore();
      }],
    },
  };
}
